export { EventCategory } from './EventCategory';
export type { IEvent } from './Event';
export type { IItem } from './Item';
export type { IPage } from './Page';
export type { IScreen } from './Screen';
export type { ITransaction } from './Transaction';
export type { IHitAbstract } from './HitAbstract';
export type { ISegment } from './Segment';
